module.exports = __webpack_public_path__ + "static/media/confidentielBGRemoved.c050b377.png";